import React from 'react'
import ForDetail from '../components/ForDetail'
import { Link } from 'react-router'
import { motion } from 'framer-motion';
import { containerVariants, itemVariants, textVariants, container, child, imageVariants } from '../script/animation';
const NewsComponent = ({ data, title }) => {
    return (
        <div className="w-full bg-red grid grid-cols-11 relative ">

            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible" className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 z-50  mt-10 mb-5 ">
                <motion.h2 variants={textVariants} className='font-bold text-30 text-genesisBlue'>{title}</motion.h2>
            </motion.div>




            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible" className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 z-50 pb-20  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-3 ">
                {
                    data.map((item, index) => {
                        return (
                            <motion.div variants={itemVariants} key={index} className=''>
                                <Link to={item.link}>
                                    <div className='group'>
                                        <motion.div className='overflow-hidden aspect-video'>
                                            <motion.img variants={imageVariants} src='/images/sirket-haberleri/0.jpg' className='h-full object-cover w-full' />
                                        </motion.div>
                                        <div className='flex'>


                                            <div className='bg-customGold  px-2 py-3  font-bold flex justify-center items-center'>
                                                <div className='flex flex-col px-2'>
                                                    <motion.div variants={textVariants} className='text-24'>{item.day}</motion.div>
                                                    <motion.div variants={textVariants} className='text-18'>{item.month}</motion.div>
                                                </div>
                                            </div>


                                            <div className=' w-full bg-genesisBlue py-3  text-white pl-[5%] pr-[10%]'>
                                                <motion.div variants={textVariants} className='w-full bg-genesisBlue py-3 text-white pl-[5%] pr-[10%]'>
                                                    {item.text[0].length > 40 ? `${item.text[0].slice(0, 40)}...` : item.text[0]}
                                                </motion.div>
                                            </div>


                                        </div>
                                        <motion.div variants={textVariants}>
                                            <ForDetail />
                                        </motion.div>
                                    </div>
                                </Link>
                            </motion.div>
                        )
                    })



                }
            </motion.div>



        </div>
    )
}

export default NewsComponent